import EventBasic from './event-basic';
import UserBasic from '../user/gd-user-basic';
import CompanyBasic from '../company/company-basic';

import Moment from 'moment';
import DatetimeUtils from "core/gd/utils/datetime-utils";

const debug = false
// const debug = "GDEvent"

const GDEvent = EventBasic.extend({
    props: {
        user: 'object',
        project: 'object',
        company: 'object',

        task: 'object',
        tags: 'array',

        meeting: 'object',

        viewStart: 'object'
    },

    children: {
        assignedToUser: UserBasic
    },

    initFromSession() {
        if (this.companyId)         this.company = gd.session.companies.get(this.companyId);
        if (this.projectId)         this.project = gd.session.projects.get(this.projectId);
        if (this.userId)            this.user = gd.session.users.get(this.userId);
        if (this.assignedToUserId)  this.assignedToUser = gd.session.users.get(this.assignedToUserId);
    },

    _isSameValue(paramName, value) {
        if (Moment.isMoment(this[paramName])) {
            // console.log("isSameValue", DatetimeUtils.momentToDate(this[paramName]), DatetimeUtils.dateTruncTime(value), DatetimeUtils.isSame(this[paramName], DatetimeUtils.dateToMoment(value), 'day'))
            return DatetimeUtils.isSame(this[paramName], DatetimeUtils.dateToMoment(value), 'day')
        } else {
            return _.isEqual(this[paramName],value)
        }
    },

    applyEventDelta(data) {
        debug && console.log(debug, "applyEventDelta()", data, this.toJSON())

        let isChanged = false

        _.mapKeys(data, (value ,key)=>{
            if (key === 'id') return;

            debug && console.log(debug, "applyEventDelta key=", key, !this._isSameValue(key, value), this[key], value)

            if (!this._isSameValue(key, value)) {

                debug && console.log(".....set", key, "neValue", value)

                switch (key) {
                    case 'startDate':
                    case 'endDate'  : this[key] = DatetimeUtils.dateToMoment(value); break;

                    default         : this[key] = value
                }

                isChanged = true
            }
        });

        debug && console.log(debug, "....applyEventDelta isChanged", isChanged, this.toJSON())

        return isChanged
    },

    applyTaskDelta(data) {
        debug && console.log(debug, "applyTaskDelta()", data, this.toJSON())

        let isChanged = false, newValue
        switch (this.type) {
            case gd.const.event.type.TASK_DEADLINE:
                if (data.hasOwnProperty('deadline')) {
                    newValue = data.deadline ? Moment(data.deadline) : null
                    if (!DatetimeUtils.isSame(this.startDate, newValue)) {
                        isChanged = true
                        this.startDate = newValue
                    }
                }
                break

            case gd.const.event.type.TASK_SCHEDULE:
                if (data.hasOwnProperty('scheduleDate')) {
                    newValue = data.scheduleDate ? Moment(data.scheduleDate) : null
                    if (!DatetimeUtils.isSame(this.startDate, newValue)) {
                        isChanged = true
                        this.startDate = newValue
                    }
                }
                break

            case gd.const.event.type.TASK_START_END:
                if (data.hasOwnProperty('startDate')) {
                    newValue = data.startDate ? Moment(data.startDate) : null
                    if (data.hasOwnProperty('startDate') && !DatetimeUtils.isSame(this.startDate, newValue)) {
                        isChanged = true
                        this.startDate = newValue
                    }
                }

                if (data.hasOwnProperty('endDate')) {
                    newValue = data.endDate ? Moment(data.endDate) : null
                    if (data.hasOwnProperty('endDate') && !DatetimeUtils.isSame(this.endDate, newValue)) {
                        isChanged = true
                        this.endDate = newValue
                    }
                }
                break
        }

        _.mapKeys(data, (value ,key)=>{
            if (key === 'id') return

            debug && console.log(debug, "applyTaskDelta key=", key, this.task[key], value)

            switch (key) {
                case 'latestActivityDate'       : this.task.recentActivityMoment = value; break
                case 'actionRequiredSinceDate'  : /*skip*/ break
                case 'taskStatusId'             :
                    if (this.task.statusId !== value) {
                        isChanged = true
                        this.task.statusId = value
                    }
                    break;
                case 'systemStatusId'           :
                    if (this.task.systemStatus !== value) {
                        isChanged = true
                        this.task.systemStatus = value
                        this.isAccomplished = gd.const.systemStatus.isClosed(this.task.systemStatus)
                    }
                    break;

                case 'projectId'                :
                    if (this.task.parentId !== value || this.task.projectId !== value) {
                        isChanged = true
                        this.task.parentId = value
                        this.task.projectId = value
                        this.projectId = value
                        if (this.projectId) this.project = gd.session.projects.get(this.projectId)
                    }
                    break

                case 'title'                    :
                    if (this.task[key] !== value) {
                        isChanged = true
                        this.task[key] = value
                        this.name = value
                    }
                    break

                case 'assignedToUserId'         :
                    if (this.task[key] !== value) {
                        isChanged = true
                        this.task[key] = value
                        this[key] = value
                    }
                    break

                case 'tags'         :
                    if (this.task[key] !== value) {
                        isChanged = true
                        this.task[key] = value
                        this[key] = value
                    }
                    break

                default                         :
                    if (this.task[key] !== value) {
                        isChanged = true
                        this.task[key] = value
                    }

            }
        })

        debug && console.log(debug, "....applyTaskDelta isChanged", isChanged, this.toJSON())

        return isChanged
    },

    applyMeetingDelta(data) {
        debug && console.log(debug, "applyMeetingDelta()", data, this.toJSON())

        let isChanged = this.meeting.applyDelta(data)

        this.name       = this.meeting.name
        this.projectId  = this.meeting.projectId
        this.startDate  = this.meeting.startMoment ? DatetimeUtils.dateToMoment(DatetimeUtils.dateTruncTime(this.meeting.startMoment)) : null
        this.endDate    = this.meeting.endMoment ? DatetimeUtils.dateToMoment(DatetimeUtils.dateTruncTime(this.meeting.endMoment)) : null

        debug && console.log(debug, "....applyMeetingDelta isChanged", isChanged, this.toJSON())

        return isChanged
    },

    toFullCalendar: function(){

        return {
            id              : this.id,
            title           : this.name,
            allDay          : true,
            start           : this.startDate ? this.startDate.format('YYYY-MM-DD') : null,
            end             : this.endDate ? Moment(this.endDate).add(1,'day').format('YYYY-MM-DD') : null,
            eventObject     : this,
            startEditable   : gd.ac.check.event.canEditEvent(this) && !this.isAccomplished,
            eventType       : this.type
        }
    },

    parse(obj){
        EventBasic.prototype.parse.apply(this,[obj]);

        obj.user = (obj.user && obj.user.id)?new UserBasic(obj.user):null;
        //
        // if (obj.project) obj.project = new ProjectBasic(obj.project);
        if (obj.company) obj.company = new CompanyBasic(obj.company,{parse: true});

        return obj;
    }
});

module.exports = GDEvent;
